import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const samsaraTagsAdapter = getAdapter({ idFieldName: 'value' });

const samsaraTagsSlice = createSlice({
  name: 'samsaraTags',
  initialState: samsaraTagsAdapter.getInitialState({
    source: null,
  }),
  reducers: {
    setSamsaraTags: (state, { payload: { samsaraTags, source } }) => {
      samsaraTagsAdapter.setAll(state, samsaraTags);
      state.source = source;
    },
  },
});

const selectors = samsaraTagsAdapter.getSelectors(({ samsaraTags }) => samsaraTags);

export const getSamsaraTags = (state) => selectors.selectAll(state);

export const { setSamsaraTags } = samsaraTagsSlice.actions;

export default samsaraTagsSlice.reducer;
